import axios from 'axios';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  const api = axios.create({
    baseURL: config.public.apiBase,
  });

  // Request interceptor
  api.interceptors.request.use(
    async (config) => {
      // Add a 1 second delay to simulate real-world conditions
      // await addDelay(500);

      // define user
      const authStore = useAuthStore();
      if (authStore.token) {
        config.headers['Authorization'] = `Bearer ${authStore.token}`;
      }

      // define current workspace
      const workspaceStore = useWorkspaceStore();
      if (workspaceStore.currentWorkspace) {
        config.headers['x-workspace-id'] = workspaceStore.currentWorkspace.id;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor (optional)
  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Example: redirect to login if 401
      if (error.response && error.response.status === 401) {

        // logout
        const authStore = useAuthStore();
        authStore.logout();

        // redirect to login
        const router = useRouter();
        router.push('/auth/login');
      }
      return Promise.reject(error);
    }
  );

  return {
    provide: {
      api,
    },
  };
});